class CanvasDrawableElement {
    constructor(type = "circle") {
        this.type = type
    }

    draw(context) {

    }
}

export default CanvasDrawableElement